const propertiesManager = require('../customizer/properties');
const builder = require('../builder-componenets');

module.exports = {

    handleFieldClick: function () {

        let fieldClicked = false,
            _this = this,
            $body = $('body'),
            rel_field_request = null,
            alert_field_request = null,
            btn_field_request = null;

        $body.on('click', '.section-field-container', function (e) {
            e.preventDefault();

            let propsContent = $('.propertiesContent'),
                field = $(this).find('.propsControl'),
                curr_table = $('.builder-main').data('id');

            $('.tab-control').removeClass('active');
            $('.propertiesTabHeader').addClass('active');

            fieldClicked = true;

            // Delete all activeFields and add one to the selected item
            $body.find('.propsControl').removeClass('activeField');

            field.addClass('activeField');

            let fieldType;

            if (typeof field.data('field') == 'undefined') {
                fieldType = field.find('input').eq(0).data('field');
            } else {
                fieldType = field.data('field');
            }

            if (rel_field_request) {
                rel_field_request.abort();
            }

            if (alert_field_request) {
                alert_field_request.abort();
            }

            if (btn_field_request) {
                btn_field_request.abort();
            }

            if (fieldType === 'relationship') {
                let tablesOpt = '',
                    type = field.data('type'),
                    label = field.data('label'),
                    name = field.data('name'),
                    hint = field.data('hint'),
                    isRelated = field.data('related'),
                    relatedId = field.data('relid'),
                    required = field.data('required'),
                    nonzero = field.data('nonzero'),
                    height = field.data('height'),
                    width = field.data('width'),
                    primary_column = field.data('primary-column'),
                    filter_column = field.data('filter-column'),
                    related_filter = field.data('related-filter'),
                    relation_type = field.data('related-type'),
                    scanner = field.data('scanner'),
                    mappings = field.data('mappings'),
                    primary_keys = field.data('primary-keys');

                rel_field_request = $.ajax({
                    type: "GET",
                    url: "/get-all-tables",
                    success: (data) => {

                        for (let table of data) {
                            tablesOpt += `<option value="${table.id}" >${table.label}</option>`;
                        }

                        let propsData = builder.fieldSettings(tablesOpt, fieldType)
                        propsContent.html(propsData);

                        $body.find('.propertiesContent [data-field="label"]').val(label);
                        $body.find('.propertiesContent [data-field="name"]').val(name);
                        $body.find('.propertiesContent [data-field="hint"]').val(hint);
                        $body.find('.propertiesContent [data-field="width"]').val(width);
                        $body.find('.propertiesContent [data-field="height"]').val(height);

                        if (isRelated) {
                            $('.propertiesContent').find('.showfields').val(relatedId).change();
                            $('.propertiesContent').find('.relation_type').val(relation_type).change();
                            propertiesManager.renderMappings(mappings);
                        }
                        if (primary_column) {
                            $('.select-primary-column').val(primary_column);
                        }

                        if (scanner) {
                            $('.propertiesContent').find('[data-field="scanner"]').prop('checked', true);
                        }

                        if (filter_column) {
                            $('.select-filter-column').val(filter_column);
                        }

                        if (related_filter) {
                            $('.related-filter').val(related_filter);
                        }

                        if (required) {
                            $('.propertiesContent').find('[data-field="required"]').prop('checked', true);
                        }

                        if (nonzero) {
                            $('.propertiesContent').find('[data-field="nonzero"]').prop('checked', true);
                        }

                        if (type) {
                            // $('body').find(".propertiesContent").find('.relation_type').val(type).trigger('change');
                        }

                        if (field.data('id')) {
                            $('body').find('.propertiesContent [data-field="name"]').attr('readonly', true);
                        }

                        _this.renderPrimaryKeys(primary_keys);
                    }
                });
            } else if (fieldType === 'alert') {
                let label = field.data('label'),
                    name = field.data('name'),
                    hint = field.data('hint'),
                    required = field.data('required'),
                    nonzero = field.data('nonzero'),
                    height = field.data('height'),
                    width = field.data('width'),
                    curr_table = $('.builder-main').data('id'),
                    alert_type = field.data('alert-type'),
                    event_field = field.data('alert-field'),
                    event_option = field.data('alert-option'),
                    value = field.data('value');

                alert_field_request = $.ajax({
                    type : "GET",
                    url : `/tablebuilder/${curr_table}/datetime`,
                    success : (data) => {
                        let datetime_fields = '';
                        for (let field of data) {
                            datetime_fields += `<option value="${field.id}">${field.label}</option>`;
                        }
                        let propsData = builder.fieldSettings(datetime_fields, fieldType);

                        propsContent.html(propsData);
                        $body.find('.propertiesContent [data-field="label"]').val(label);
                        $body.find('.propertiesContent [data-field="name"]').val(name);
                        $body.find('.propertiesContent [data-field="hint"]').val(hint);
                        $body.find('.propertiesContent [data-field="width"]').val(width);
                        $body.find('.propertiesContent [data-field="height"]').val(height);

                        if (alert_type) {
                            $('.alert-type').val(alert_type).trigger('change');
                        }

                        if (event_field) {
                            $('.alert-field').val(event_field).trigger('change');
                        }

                        if (event_option) {
                            $('.alert-option').val(event_option).trigger('change');
                        }

                        if (value) {
                            $('.custom-value-date').val(value).trigger('change');
                        }

                        if (required) {
                            $('.propertiesContent').find('[data-field="required"]').prop('checked', true);
                        }

                        if (nonzero) {
                            $('.propertiesContent').find('[data-field="nonzero"]').prop('checked', true);
                        }

                        if (field.data('id')) {
                            $('body').find('.propertiesContent [data-field="name"]').attr('readonly', true);
                        }

                        $('.selectpicker').selectpicker('refresh');
                    }
                });
            } else {

                let propsContent = $('.propertiesContent');
                let label,
                    hint,
                    name,
                    required,
                    nonzero,
                    unique,
                    capital,
                    options,
                    height,
                    width,
                    view_only,
                    isRelated,
                    relatedId,
                    type,
                    pattern,
                    relfields,
                    colors,
                    pattern_enabled,
                    auto_field_type,
                    default_value;

                // Get Active Field
                let field = $(this).find('.activeField');
                let fieldType = field.data('field');
                if (fieldType === 'relationship') {
                    return false;
                }
                let insidefield = $('body').find('.activeField').find('input');
                let insidefieldType = insidefield.data('field');

                // Store Data
                if (fieldType) {
                    label = field.data('label');
                    name = field.data('name');
                    hint = field.data('hint');
                    options = field.data('values');
                    required = field.data('required');
                    nonzero = field.data('nonzero');
                    unique = field.data('unique');
                    capital = field.data('capital');
                    height = field.data('height');
                    width = field.data('width');
                    view_only = field.data('view-only');
                    isRelated = field.data('related');
                    relatedId = field.data('relid');
                    pattern = field.data('pattern');
                    auto_field_type = field.data('auto-type');
                    default_value = field.data('default');
                    type = field.data('type');
                    relfields = field.data('relfields');

                    colors = field.data('option-colors');
                    colors = colors ? colors : [];

                    label = (label != null) ? label : 'Untitled';
                    name = (name != null) ? name : 'Untitled';
                    hint = (hint != null) ? hint : 'Untitled';
                    options = (options != null) ? options : 'Option';
                    required = (required != null) ? required : 0;
                    nonzero = (nonzero != null) ? nonzero : 0;
                    unique = (unique != null) ? unique : 0;
                    isRelated = (isRelated != null) ? isRelated : 0;
                    relatedId = (relatedId != null) ? relatedId : '';
                    pattern = (pattern != null) ? pattern : '';
                    type = (type != null) ? type : '';
                    relfields = (relfields != null) ? relfields : '',
                        pattern_enabled = field.data('pattern-enabled');

                    let automation_id = field.data('automation-id'),
                        message = field.data('message'),
                        btn_color = field.data('btn-color'),
                        btn_text_color = field.data('btn-text-color');

                    propsContent.html(builder.fieldSettings(null, fieldType));
                    _this.manageFieldsProps();

                    $body.find('.propertiesContent [data-field="label"]').val(label);
                    $body.find('.propertiesContent [data-field="name"]').val(name);
                    $body.find('.propertiesContent [data-field="hint"]').val(hint);
                    $body.find('.propertiesContent [data-field="width"]').val(width);
                    $body.find('.propertiesContent [data-field="height"]').val(height);

                    if (fieldType === 'button') {
                        let automationOpts = '<option value="">Select automation</option>';

                        btn_field_request = $.ajax({
                            type : "GET",
                            url : `/get-all-automations/${curr_table}`,
                            success : (data) => {
                                for (let automation of data) {
                                    automationOpts += `<option value="${automation.id}">${automation.description ? automation.description : `Automation ID # ${automation.id}`}</option>`;
                                }
                                $('.propsChange[data-field="automation-id"]').html(automationOpts).val(automation_id);
                            }
                        })

                        if (message) {
                            $('body').find(".propertiesContent").find('[data-field="message"]').val(message);
                        }
                        $('.btn-text-color, .btn-color').colorpicker({
                            format: "hex",
                            autoInputFallback: false,
                            useAlpha: true
                        });
                        let $input = $('.btn-text-color').find('input');
                        $($input).val(btn_text_color).trigger('change');
                        $input = $('.btn-color').find('input');
                        $($input).val(btn_color).trigger('change');
                    }

                    if (required) {
                        $('body').find(".propertiesContent").find('[data-field="required"]').prop('checked', true);
                    }

                    if (nonzero) {
                        $('body').find(".propertiesContent").find('[data-field="nonzero"]').prop('checked', true);
                    }

                    if (default_value === 'yes') {
                        $('body').find(".propertiesContent").find('[data-field="default"]').prop('checked', true);
                    }

                    if (unique) {
                        $('body').find(".propertiesContent").find('[data-field="unique"]').prop('checked', true);
                    }

                    if (capital) {
                        $('body').find(".propertiesContent").find('[data-field="capital"]').prop('checked', true);
                    }

                    if (view_only) {
                        $('body').find(".propertiesContent").find('[data-field="view_only"]').prop('checked', true);
                    }

                    if (pattern) {
                        $('body').find(".propertiesContent").find('[data-field="pattern"]').val(pattern);
                    }

                    if (!(type === 'date' || type === 'datetime' || type === 'decimal' || type === 'number' || type === 'select' || type === "multipleselect")) {
                        if (fieldType === 'date') {
                            $('body').find(".propertiesContent").find('.propsChange[data-field="date-time"]').val(type).trigger('change');
                        }
                    } else {
                        $('body').find(".propertiesContent").find('.propsChange[data-field!="width"][data-field!="height"]').val(type).trigger('change');
                    }

                    if (fieldType === 'formula') {
                        $('.propsField[data-field="formula"]').val(field.data('value'));
                    }

                    $('.propsChange[data-field="auto_field_type"]').val(auto_field_type);

                    if (field.data('id')) {
                        $('.propsField[data-field="name"]').attr('readonly', true);
                        $('.auto-pattern-holder').addClass('d-none');
                        $('.auto-field-type').attr('disabled', true);

                        // if (!pattern_enabled) {
                        //     $('.pattern-container').addClass('d-none');
                        // } else {
                        //     $('.propsField[data-field="pattern"]').prop('disabled', false);
                        // }
                    } else {
                        $('.auto-field-type').attr('disabled', false);
                        $('.propsField[data-field="pattern"]').prop('disabled', !pattern_enabled);
                        $('.propsChange[data-field="enable_pattern"]').prop('checked', pattern_enabled);
                    }

                    if (field.data('field') === 'select' || field.data('field') === 'multipleselect') {

                        let optionsContainer = $('body').find(".propertiesContent").find('.options-blocks');
                        let content = `<p class="mb-1">Options</p>`;

                        if (field.data('field') === 'multipleselect') {
                            optionsContainer.addClass('multipleOptions');
                        }

                        if (Array.isArray(options)) {

                            $(options).each(function (e, v) {
                                content += `<div class="input-group mb-1 option-block">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text orderSelectopt">
                                                <i class="fas fa-arrows-alt"></i>
                                            </span>
                                        </div>
    
                                        <input
                                            type="text"
                                            class="form-control propsField selectField"
                                            data-field="values"
                                            value="${v}">
    
                                        <div class="input-group-append">
                                            <span class="input-group-text deleteSelectopt">
                                                <i class="fas fa-times"></i>
                                            </span>
                                        </div>
                                        ${field.data('field') === 'select' ?
                                    `<div class="input-group-append change_option" style="margin-left: 10px;" data-color="${colors[e] ? colors[e] : '#0162A7'}">
                                                <input type="text" class="form-control input-lg" style="width:100px;" value="${colors[e] ? colors[e] : '#0162A7'}" />
                                                <span class="input-group-append">
                                                    <span class="input-group-text colorpicker-input-addon"><i></i></span>
                                                </span>
                                            </div>` : ''}
                                        </div> `;
                            })

                        } else {
                            content += `<div class="input-group mb-1 option-block">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text orderSelectopt">
                                            <i class="fas fa-arrows-alt"></i>
                                        </span>
                                    </div>
    
                                    <input
                                        type="text"
                                        class="form-control propsField selectField"
                                        data-field="values"
                                        value="${options}">
    
                                    <div class="input-group-append">
                                        <span class="input-group-text deleteSelectopt">
                                            <i class="fas fa-times"></i>
                                        </span>
                                    </div>
                                </div> `;
                        }

                        optionsContainer.html(content);
                    }
                } else if (insidefieldType) {

                    let activeElm = $('body').find('.activeField');
                    var labelname = activeElm.find('.multipicklist_data').data('lblname');
                    var fieldname = activeElm.find('.multipicklist_data').data('fieldname');

                    label = insidefield.data('label');
                    name = insidefield.data('name');
                    hint = insidefield.data('hint');
                    options = insidefield.data('values');
                    required = insidefield.data('required');
                    nonzero = insidefield.data('nonzero');
                    unique = insidefield.data('unique');
                    capital = insidefield.data('capital');
                    height = field.find('.fieldItem').data('height');
                    width = field.find('.fieldItem').data('width');
                    isRelated = insidefield.data('related');
                    relatedId = insidefield.data('relid');
                    Type = insidefield.data('type');

                    label = (label != null) ? label : 'Untitled';
                    name = (name != null) ? name : 'Untitled';
                    hint = (hint != null) ? hint : 'Untitled';
                    options = (options != null) ? options : 'Option';
                    required = (required != null) ? required : 0;
                    nonzero = (nonzero != null) ? nonzero : 0;
                    unique = (unique != null) ? unique : 0;
                    isRelated = (isRelated != null) ? isRelated : 0;
                    relatedId = (relatedId != null) ? relatedId : '';
                    Type = (Type != null) ? Type : '';
                    colors = insidefield.data('option-colors');
                    colors = colors ? colors : [];

                    propsContent.html(builder.fieldSettings(null, insidefieldType));
                    _this.manageFieldsProps();

                    $body.find('.propertiesContent [data-field="width"]').val(width);
                    $body.find('.propertiesContent [data-field="height"]').val(height);

                    if (required) {
                        $('body').find(".propertiesContent").find('[data-field="required"]').prop('checked', true);
                    }

                    if (nonzero) {
                        $('body').find(".propertiesContent").find('[data-field="nonzero"]').prop('checked', true);
                    }

                    if (insidefield.data('id')) {
                        $('.propsField[data-field="name"]').attr('readonly', true);
                    }

                    if (typeof labelname != 'undefined' && typeof fieldname != 'undefined') {
                        $('body').find('.propertiesContent [data-field="label"]').val(labelname);
                        $('body').find('.propertiesContent [data-field="name"]').val(fieldname);
                    } else {
                        $('body').find('.propertiesContent [data-field="label"]').val(label);
                        $('body').find('.propertiesContent [data-field="name"]').val(name);
                    }

                    $('body').find('.propertiesContent [data-field="hint"]').val(hint);

                    if (insidefieldType == 'radio' || insidefieldType == 'multiselect') {
                        $('body').find(".propertiesContent").find('.propsChange[data-field!="width"][data-field!="height"]').val(insidefieldType).trigger('change');
                    }

                    let activeElinner = $('body').find('.activeField input:first-child');

                    if (required == '1') {
                        activeElinner.data('required', 1);
                    } else {
                        activeElinner.data('required', 0);
                    }


                    if (insidefield.data('field') == 'multiselect' || insidefield.data('field') == 'radio') {
                        let optionsContainer = $('body').find(".propertiesContent").find('.options-blocks')
                        let content = `<p class="mb-1">Options</p>`;
                        let checkOptions = [];
                        let inputs = $(this).find('input');
                        inputs.each(function () {
                            checkOptions.push($(this).data('value'));
                        });

                        $(checkOptions).each(function (e, v) {
                            content += `<div class="input-group mb-1 option-block">
        
                                    <div class="input-group-prepend">
                                        <span class="input-group-text orderSelectopt">
                                            <i class="fas fa-arrows-alt"></i>
                                        </span>
                                    </div>
        
                                    <input
                                        type="text"
                                        class="form-control propsField selectField"
                                        data-field="values"
                                        value="${v}">
        
                                    <div class="input-group-append">
                                        <span class="input-group-text deleteSelectopt">
                                            <i class="fas fa-times"></i>
                                        </span>
                                    </div>
                                    
                                    <div class="input-group-append change_option" style="margin-left: 10px;" data-color="#0162A7">
                                            <input type="text" class="form-control input-lg" style="width:100px;" value="#0162A7" />
                                            <span class="input-group-append">
                                            <span class="input-group-text colorpicker-input-addon"><i></i></span>
                                        </span>
                                    </div>
                                </div> `;

                        })

                        optionsContainer.html(content);
                    }


                    var returnTOcustomize = $(this).find('.activeField ');
                    if (returnTOcustomize.hasClass('for_multivalue')) {
                        if (insidefieldType == 'radio' || insidefieldType == 'multiselect') {

                            let optionsContainer = $('body').find(".propertiesContent").find('.options-blocks')
                            let content = `<p class="mb-1">Options</p>`;

                            let radio_option = options;

                            console.log(colors);

                            optionsContainer.html('');

                            if (Array.isArray(radio_option)) {
                                $(radio_option).each(function (e, v) {
                                    content += `<div class="input-group mb-1 option-block">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text orderSelectopt">
                                                            <i class="fas fa-arrows-alt"></i>
                                                        </span>
                                                    </div>
                        
                                                    <input
                                                        type="text"
                                                        class="form-control propsField selectField"
                                                        data-field="values"
                                                        value="${v}">
                        
                                                    <div class="input-group-append">
                                                        <span class="input-group-text deleteSelectopt">
                                                            <i class="fas fa-times"></i>
                                                        </span>
                                                    </div>
                                                    
                                                    ${insidefieldType == 'radio' ?
                                        `<div class="input-group-append change_option" style="margin-left: 10px;" data-color="${colors[e] ? colors[e] : '#0162A7'}">
                                                            <input type="text" class="form-control input-lg" style="width:100px;" value="${colors[e] ? colors[e] : '#0162A7'}" />
                                                            <span class="input-group-append">
                                                                <span class="input-group-text colorpicker-input-addon"><i></i></span>
                                                            </span>
                                                        </div>`
                                        : ''}
                                                </div> `;

                                })
                                optionsContainer.html(content);
                            } else {
                                let optionsContainer = $('body').find(".propertiesContent").find('.options-blocks')
                                let content = `<p class="mb-1">Options</p>`;
                                let checkOptions = [];
                                let inputs = $(this).find('input');
                                inputs.each(function () {
                                    checkOptions.push($(this).data('value'));
                                })
                                $(checkOptions).each(function (e, v) {

                                    content += `<div class="input-group mb-1 option-block">
                    
                                            <div class="input-group-prepend">
                                                <span class="input-group-text orderSelectopt">
                                                    <i class="fas fa-arrows-alt"></i>
                                                </span>
                                            </div>
                    
                                            <input
                                                type="text"
                                                class="form-control propsField selectField"
                                                data-field="values"
                                                value="${v}">
                    
                                            <div class="input-group-append">
                                                <span class="input-group-text deleteSelectopt">
                                                    <i class="fas fa-times"></i>
                                                </span>
                                            </div>
                                        </div> `;
                                });
                                optionsContainer.html(content);
                            }

                        }
                    }
                }
                fieldClicked = false;

                $('.change_option').colorpicker({
                    format: "hex",
                    autoInputFallback: false,
                    useAlpha: true
                });
            }

            // Show/Hide Fields/Properties Tabs
            _this.manageFieldsProps();
        })
    },

    manageFieldsProps() {

        let propsTab = $('.propertiesTabHeader');
        let fieldsTab = $('.fieldsTabHeader');
        let propsContent = $('.propertiesContent');
        let fieldsContent = $('.fieldsContent');

        propsTab.show();
        propsContent.show();
        fieldsContent.hide();

        propsTab.on('click', function (e) {
            $(this).addClass('active');
        });

        fieldsTab.on('click', function (e) {
            e.preventDefault();
            propsTab.hide();
            fieldsTab.show();
            propsContent.html('').hide();
            fieldsContent.show();
            $('.tab-control').removeClass('active');

            $(this).addClass('active');
            $('body').find('.fieldsSection').removeClass('activeSection');
            $('body').find('.propsControl').removeClass('activeField');
        });
    },

    createNewFields() {
        let createNewField = $('#selectFieldsTable');
        createNewField.on('change', function (e) {
            window.location.href = `/tablebuilder/${$(this).val()}`
        })
    },

    orderFields() {
        $(".sectionBody").sortable({
            items: ".section-field-container",
            tolerance: "pointer",
            handle: ".orderField",
            update: function (e, ui) {
                let items = ui.item.closest('.ui-sortable').find('.section-field-container');
                items.each(function () {
                    let i = $(this).index() + 1;
                    $(this).find('.fieldItem').attr('data-order', i);
                });
            }
        });
        $(".sectionBody .section-field-container").disableSelection();
    },

    renderPrimaryKeys(keys) {
        if (keys && keys.length) {
            let related_table = $('.showfields[data-field="related-to"]').val(),
                curr_table = $('.builder-main').data('id'),
                header = $('.relation-keys').find('.row').length === 0 ? 'yes' : 'no';

            if (header === 'yes') {
                $.ajax({
                    type: 'GET',
                    url: '/tablebuilder/section/primary_key',
                    data: {
                        related_table: related_table,
                        curr_table: curr_table,
                        primary_keys: keys,
                        header: header,
                        type: 'primary_key'
                    },
                    success: (res) => {
                        $('.relation-keys-holder').find('.relation-keys').empty().append(res);
                        $('.current-primary-key').trigger('change');
                        $('.related-primary-key').trigger('change');
                    }
                });
            }
        }
    },
};